export const studyRevisionAttributesNameMaxLength = 60;
export const studyRevisionAttributesDescriptionMaxLength = 250;
export function toStudyRevisionAttribute(attribute) {
    return {
        name: attribute.name,
        description: attribute.description,
    };
}
//# sourceMappingURL=study-revision-attribute.js.map